import { IS_BROWSER } from 'Constants/Detection';

export function paramsToObj(paramsString) {
  return paramsString
    .replace(/(^\?)/, '')
    .split('&')
    .reduce((acc, param) => {
      const params = param.split('=');
      if (params[0] && params[1]) acc[params[0]] = params[1];
      return acc;
    }, {});
}

const queryParams = !IS_BROWSER ? {} : paramsToObj(window.document.location.search);

export default queryParams;
